export default __webpack_public_path__ + "static/media/CADILLAC.19865133.png";